/* eslint-disable vue/require-valid-default-prop */
import { computed, defineComponent, ref, watch } from 'vue';
import './index.less';
import dayjs, { Dayjs } from 'dayjs';
import { Plugin } from '@vue/runtime-dom';
import {
  curMonthDateLastTime,
  curMonthDateStartTime,
  curWeekDateEndTime,
  curWeekDateStartTime,
  curYearDateEndTime,
  curYearDateStartTime,
  currentMonthDate,
  currentWeekDate,
  formatCurrentDate,
  lastYearDateString,
  todayDateString,
} from '../../utils/date_util';

const Dtimepicker = defineComponent({
  props: {
    showFileter: { type: Boolean, default: true },
    title: { type: String, default: undefined },
    filterDate: { type: String, default: 'month' },
    dateFilterOptionValue: { type: Array as PropType<Partial<any>[]> },
    defaultValue: {
      type: Array as PropType<Partial<string>[]>,
    },
    dateRangeOptions: {
      type: Array as PropType<Partial<{
        label: string;
        value: string;
      }>[]>,
      default: () => [
        {
          label: '天',
          value: 'day', 
        },
        {
          label: '周',
          value: 'week',
        },
        {
          label: '月',
          value: 'month',
        },
        {
          label: '季度',
          value: 'quarter',
        },
      ],
      required: false,
    },
  },
  emits: ['update:filterDate', 'update:filterPicker'],
  setup(props, { emit }) {
    const tfilterDate = ref<string>('month');
    // const filterPicker = ref<[string, string]>(['2023-01-01', '2024-01-01']);
    const pickerValue = computed(
      () => props.defaultValue && props.defaultValue.map((item) => dayjs(item, 'YYYY-MM-DD'))
    );

    const disabledDate = (current: Dayjs) => {
      // Can not select days before today and today
      return current && current > dayjs().endOf('day');
    };
    watch(
      () => props.filterDate,
      (newVal) => {
        tfilterDate.value = newVal;
      },
      { immediate: true }
    );
    const dateVisible = ref(false);

    const dateFilterOption = computed(
      () =>
        props.dateFilterOptionValue ?? [
          {
            label: '最近一周',
            value: () => `${currentWeekDate()} ~ ${formatCurrentDate()}`,
            isActive: false,
          },
          {
            label: '最近一月',
            value: () => `${currentMonthDate()} ~ ${formatCurrentDate()}`,
            isActive: false,
          },
          {
            label: '最近一年',
            value: () => `${lastYearDateString} ~ ${todayDateString}`,
            isActive: true,
          },
          {
            label: '本周',
            value: () => `${curWeekDateStartTime()} ~ ${curWeekDateEndTime()}`,
            isActive: false,
          },
          {
            label: '本月',
            value: () => `${curMonthDateStartTime()} ~ ${curMonthDateLastTime()}`,
            isActive: false,
          },
          {
            label: '本年',
            value: () => `${curYearDateStartTime()} ~ ${curYearDateEndTime()}`,
            isActive: false,
          },
        ]
    );

    // watch(
    //   () => props.dateFilterOptionValue,
    //   () => {
    //     if (props.dateFilterOptionValue) {
    //       dateFilterOption = [...props.dateFilterOptionValue] as any[];
    //     }
    //   }
    // );

    const currentDateFilter = ref(
      dateFilterOption.value.findLast((item) => item.isActive)?.value()
    );
    const onRangeChange = (value: [Dayjs, Dayjs], dateString: [string, string]) => {
      dateFilterOption.value.forEach((item) => {
        item.isActive = false;
      });
      currentDateFilter.value = `${dateString[0]} ~ ${dateString[1]}`;
      refreshPickTime();
    };
    /**
     * 搜索用户
     * @param data 关键字
     */
    const dataFilterClick = async (data) => {
      currentDateFilter.value = data.value();
      dateFilterOption.value.forEach((data) => {
        data.isActive = false;
      });
      data.isActive = true;
      refreshPickTime();
      dateVisible.value = false;
    };

    // 日期选择器
    const refreshPickTime = () => {
      const startTime = currentDateFilter.value ? currentDateFilter.value.split('~')[0].trim() : '';
      const endTime = currentDateFilter.value ? currentDateFilter.value.split('~')[1].trim() : '';
      emit('update:filterPicker', [startTime, endTime]);
    };

    return {
      tfilterDate,
      pickerValue,
      disabledDate,
      dateVisible,
      dateFilterOption,
      currentDateFilter,
      onRangeChange,
      dataFilterClick,
    };
  },
  render() {
    return (
      <div class="dashboard-time-picker-filter">
        {this.title && <div style={{}}>{this.title}:</div>}
        {this.showFileter && (
          <a-radio-group
            v-model:value={this.tfilterDate}
            button-style="solid"
            onChange={(e) => {
              this.tfilterDate = e.target.value;
              this.$emit('update:filterDate', e.target.value);
            }}
          >
            {
              this.dateRangeOptions.map((item) => (
                <a-radio-button value={item.value}>{item.label}</a-radio-button>
              ))
            }
          </a-radio-group>
        )}
        <div style={{ paddingLeft: '20px' }} class="form-gap">
          <a-popover
            v-model:open={this.dateVisible}
            trigger="click"
            placement="bottom"
            v-slots={{
              content: () => (
                <div>
                  {this.dateFilterOption &&
                    this.dateFilterOption.map((item) => (
                      <div
                        class={item.isActive ? 'active date-filter-item' : 'date-filter-item'}
                        onClick={() => this.dataFilterClick(item)}
                      >
                        {item.label}
                      </div>
                    ))}
                  <a-range-picker
                    format="YYYY-MM-DD HH:mm:ss"
                    allowClear={false}
                    onChange={async (a, b) => {
                      this.onRangeChange(a, b);
                    }}
                  />
                </div>
              ),
            }}
          >
            <a-input-search
              v-model:value={this.currentDateFilter}
              class="date-filter-search"
              placeholder="请选择时间"
              allowClear={false}
              search={() => {
                this.dateVisible = false;
              }}
            />
          </a-popover>
        </div>
      </div>
    );
  },
});

export const DTimePicker: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DTimepicker', Dtimepicker);
  },
};
